<template>
  <Page
    title="Profissionais"
    filterable
    :filter.sync="filter"
    @update:filter="getItems"
  >
    <template v-slot:actions>
      <div>
        <v-btn to="/admin/professionals/new" color="primary" tile>
          <v-icon left>mdi-plus</v-icon>
          Cadastrar
        </v-btn>
      </div>
    </template>
    <v-container fluid>
      <v-card width="1200">
        <v-card-title>
          Todos
          <v-spacer></v-spacer>
          <v-btn @click="getItems()" icon>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-0"
            :disabled="loading"
            :loading="loading"
            loading-text="Carregando..."
          >
            <template v-slot:item.name="{ item }">
              <router-link :to="`/admin/professionals/${item.id}`">
                {{ item.name }}
              </router-link>
            </template>
            <template v-slot:item.income="{ item }">
              <div>
                <v-btn
                  @click="handleToggleIncomeVision(item.id)"
                  class="mr-1"
                  small
                  icon
                >
                  <v-icon v-if="showIncomeOf(item.id)">mdi-eye-off</v-icon>
                  <v-icon v-else>mdi-eye</v-icon>
                </v-btn>
                <span v-if="showIncomeOf(item.id)">
                  {{ item.income }}
                </span>
                <span v-else class="font-weight-bold"> ******** </span>
              </div>
            </template>
            <template v-slot:item.birth_date="{ item }">
              <v-menu v-if="item.birth_date" open-on-hover top offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" small>
                    {{ getTimeToBirthday(item.birth_date, false) }}
                  </v-chip>
                </template>

                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title> Idade </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ getYearsOld(item.birth_date) }} anos
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title> Nascimento </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ formatDate(item.birth_date) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <span v-else class="grey--text"> N/informado </span>
            </template>
            <template v-slot:item.started_at="{ item }">
              <span> {{ formatDate(item.started_at) }} </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn @click="handleClickEditUser(item.id)" icon>
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </Page>
</template>

<script>
import { index } from "@/services/professionals";
import DateTimeMixin from "@/mixins/DateTimeMixin";
import Page from "@/components/layout/Page";

export default {
  name: "professinals-list",
  components: { Page },
  mixins: [DateTimeMixin],
  data: () => ({
    items: [],
    loading: false,
    show_income_of: [],
    filter: "",
    headers: [
      {
        text: "Profissional",
        value: "name",
        width: 350
      },
      {
        text: "Atuação",
        value: "designation",
        width: 200
      },
      {
        text: "Aniversário",
        value: "birth_date",
        width: 200
      },
      {
        text: "Início em",
        value: "started_at",
        width: 200
      }
    ]
  }),
  methods: {
    getTimeToBirthday(birth_date, hide_prefix = true) {
      const birth = this.$moment(birth_date);
      const age = this.getYearsOld(birth_date);
      let next_birthday = birth.add(age, "years");
      const days = next_birthday.diff(this.$moment(), "days");
      if (days < 0) {
        next_birthday = next_birthday.add(1, "year");
      } else if (days == 0) {
        return "hoje";
      }

      return next_birthday.fromNow(hide_prefix);
    },
    getYearsOld(birth_date) {
      const birth = this.$moment(birth_date);
      const today = this.$moment();

      return today.diff(birth, "years");
    },
    async getItems() {
      this.loading = true;
      const response = await index();
      this.items = response;
      this.loading = false;
    },
    showIncomeOf(id_to_verify) {
      return this.show_income_of.find(id => id_to_verify === id);
    },
    handleToggleIncomeVision(id) {
      if (this.showIncomeOf(id)) {
        this.show_income_of = this.show_income_of.filter(
          user_id => user_id !== id
        );
      } else {
        this.show_income_of.push(id);
      }
    }
  },
  created() {
    this.getItems();
  }
};
</script>
